import { GET_ACTIVITY_DETAILS, GET_PROFILE_DETAILS, GET_SCHOOL_PROFILE_DETAILS, UPDATE_PROFILE_DETAILS } from "../actions/ProfileActions";

const initialState = {// initialize states
  profileDetails: [],
  activityDetails: [],
  schoolProfileDetails: [],
};

const ProfileReducer = function (state = initialState, action) {
  switch (action.type) {
    case GET_PROFILE_DETAILS: { // save profiles data into state
      return { ...state, profileDetails: (action.payload.data) ? action.payload.data : [] };
    }
    case GET_ACTIVITY_DETAILS: {
      return { ...state, activityDetails: (action.payload.data) ? action.payload.data : [] };
    }
    case UPDATE_PROFILE_DETAILS: {
      return { ...state, };
    }
    case GET_SCHOOL_PROFILE_DETAILS: { // save profiles data into state
      return { ...state, schoolProfileDetails: (action.payload.data) ? action.payload.data : [] };
    }
    default: {
      return {
        ...state,
      };
    }
  }
};

export default ProfileReducer;